module.exports = __webpack_public_path__ + "static/media/card-tuluu.178285c2.png";